// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"84a0e0f0","354":"abd4c8dd","897":"2200f99c"}[chunkId] + ".chunk.js";
};